import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes ,Router} from 'react-router-dom';
import Login from './/Components/login'
ReactDOM.render(
  
    
      // <Routes>
      // <Route exact path = "/login" element={<Login />} />
      // <Route path="/" element={ <App /> }>
      //   </Route>
      // </Routes>,
   <BrowserRouter>
   
    <App />
    
  </BrowserRouter>,
 
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
reportWebVitals(console.log);
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
